import { render } from "./App.vue?vue&type=template&id=634d578a"
const script = {}
script.render = render

export default script